import { initialState } from '@/models/options';

const v25 = (state: any) => {
  return {
    ...state,
    options: {
      ...state.options,
      tableViews: {
        ...state.options.tableViews,
        invoicesTable: {
          ...initialState.tableViews.invoicesTable,
          'Payment Purpose': true,
        },
      },
    },
  };
};

export default v25;
